/* eslint-disable consistent-return */
export const getCookie = (cname: string) => {
  if (typeof window !== "undefined") {
    const name = `${cname}=`;
    // eslint-disable-next-line no-undef
    const cArr = window.document.cookie.split(";");
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < cArr.length; i++) {
      const c = cArr[i].trim();
      if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  }
  return null;
};

export default getCookie;
